import Waarning from "../../icons/Warning";

const Note = ({children, style, className}) => {

    return(
        <div style={{...styles.container, ...style}} className={className}>
            <Waarning />
            <p style={styles.text} className="caption_12_light">{children}</p>
        </div>
    )

}

const styles = {
    container:{
        display: 'flex',
        flexDirection: 'row',
        gap: 5,
        width: '100%',
        whiteSpace: 'pre-wrap'
    },
    text: {
        color: '#A7B5C8',
        flex: 1,
        margin: 0
    }
}

export default Note